module.exports = __webpack_public_path__ + "img/scan.0cb14dbb.png";